import { apiAuth } from './index';

/**
 * Response: [{
 *  invoiceId: bool
 *  isToday: bool
 *  persianDate: string
 *  feedbackComment: string
 *  feedbackNahartimeComment: string
 *  feedbackItemViewModels: [{
 *    foodItemId": bool
 *    foodItemName": string
 *    invoiceItemId": int
 *    invoiceItemPrice": int
 *    feedbackItemRate": int
 *    hasFeedbackNahartimeComment": bool
 *  }]
 * }]
 */
export const fetchFeedbackList = async () => {
	try {
		const { data } = await apiAuth.get(`/feedback/list`);
		return data;
	} catch (e) {
		throw e;
	}
};

/**
 * Response: {
 *  invoiceId: bool
 *  isToday: bool
 *  persianDate: string
 *  feedbackComment: string
 *  feedbackNahartimeComment: string
 *  feedbackItemViewModels: [{
 *    foodItemId": bool
 *    foodItemName": string
 *    invoiceItemId": int
 *    invoiceItemPrice": int
 *    feedbackItemRate": int
 *    hasFeedbackNahartimeComment": bool
 *  }]
 * }
 */
export const fetchFeedback = async (invoiceId) => {
	try {
		const { data } = await apiAuth.get(`/feedback/item?invoiceId=${invoiceId}`);
		return data;
	} catch (e) {
		throw e;
	}
};

/**
 * Response: {
 *  sumFeedBackItemRate1: int
 *  sumFeedBackItemRate2: int
 *  sumFeedBackItemRate3: int
 *  sumFeedBackItemRate4: int
 *  sumFeedBackItemRate5: int
 *  sumTotal: int
 * }
 */
export const fetchStatisticFeedbackItem = async (invoiceItemId) => {
	try {
		const { data } = await apiAuth.get(
			`/feedback/statistics?invoiceItemId=${invoiceItemId}`,
		);
		return data;
	} catch (e) {
		throw e;
	}
};

export const fetchStatisticFeedbackItems = async (invoiceItemIds) => {
	return new Promise((resolve, reject) => {
		const all = [];
		invoiceItemIds.forEach((invoiceItemId) => {
			all.push(fetchStatisticFeedbackItem(invoiceItemId));
		});

		Promise.all(all)
			.then((datas) => {
				resolve(datas);
			})
			.catch(reject);
	});
};

/**
 * Request: {
 *  invoiceId: int
 *  feedbackComment: string
 *  feedbackItemViewModels: [{
 *    invoiceItemId: int
 *    feedbackItemRate: int(1,2,3,4,5)
 *  }]
 * }
 */
export const submitFeedback = async (params) => {
	try {
		const { data } = await apiAuth.post('feedback/submit', params);
		return data;
	} catch (e) {
		throw e;
	}
};

/**
 * Response: {
 *  sumFeedBackItemRate1: int
 *  invoiceId: int
 *  isToday: bool
 *  persianDate: string
 *  feedbackComment: string
 *  feedbackNahartimeComment: string
 *  feedbackItemViewModels: []
 * }
 */
export const checkUnvotedFeedback = async () => {
	try {
		const { data } = await apiAuth.get('/feedback/checkUnvotedFeedback');
		return data;
	} catch (e) {
		throw e;
	}
};

/**
 * Response: {}
 */
export const ignoreFeedback = async (invoiceId) => {
	try {
		const { data } = await apiAuth.post(
			`/feedback/ignore?invoiceId=${invoiceId}`,
		);
		return data;
	} catch (e) {
		console.error(e)
	}
};
